const getCanonicalPath = article => {
  if (article.related.campaign && article.featured) {
    // Use campaign page as canonical if article is featured
    return article.related.campaign.web_uri.responsive;
  }
  if (article.related.category && article.featured) {
    // Use category page as canonical if article is featured
    return article.related.category.pathName;
  }
  return article.pathName;
};

export default ({ data: { article } }, { market, t }) => {
  if (!article) {
    return {};
  }

  const canonicalUrl = market.domain + getCanonicalPath(article);
  const articleUrl = market.domain + article.pathName;
  const openGraph = [
    { key: 'title', content: article.title },
    { key: 'type', content: 'article' },
    { key: 'url', content: articleUrl },
    { key: 'image', content: article.imageUrl },
  ];

  return {
    title: t('meta', 'article.page-title', { title: article.title }),
    description: article.preamble,
    canonical: canonicalUrl,
    structuredData: undefined,
    openGraph,
    // We only support hreflang tags on campaign articles for now
    hrefLang: article.related.campaign ? article.hrefLang : [],
  };
};
